import { extendTheme } from '@chakra-ui/react'

import colors from '@/constants/colors'
import { FONT_FAMILY, FONT_SIZES, FONT_WEIGHTS, LINE_HEIGHTS } from '@/constants/constants'
import semanticTokens from '@/constants/semanticTokens'

import Checkbox from '@/vendor/chakra/components/Checkbox'
import Radio from '@/vendor/chakra/components/Radio'
import Stepper from '@/vendor/chakra/components/Stepper'
import Switch from '@/vendor/chakra/components/Switch'

import Alert from './components/Alert'
import Button from './components/Button'
import CloseButton from './components/CloseButton'
import Container from './components/Container'
import Heading from './components/Heading'
import Input from './components/Input'
import Link from './components/Link'
import Menu from './components/Menu'
import Modal from './components/Modal'
import Progress from './components/Progress'
import Tabs from './components/Tabs'
import Text from './components/Text'
import Textarea from './components/Textarea'
import styles from './styles'

const overrides = {
  styles,
  colors,
  semanticTokens,
  fonts: FONT_FAMILY,
  fontSizes: FONT_SIZES,
  fontWeights: FONT_WEIGHTS,
  lineHeights: LINE_HEIGHTS,
  components: {
    Menu,
    Textarea,
    Button,
    Container,
    Checkbox,
    Heading,
    Link,
    LinkC: Link,
    Tabs,
    Text,
    Alert,
    CloseButton,
    Modal,
    Input,
    Progress,
    Radio,
    Stepper,
    Switch,
  },
}

export default extendTheme(overrides)
